import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {ClickAwayListener, Popover} from "@material-ui/core";
import {getLocalizationLanguageCode} from "../../../util/localization";
import AdminAutocompleteMenuItem from "./components/AdminAutocompleteMenuItem";
import UserAutocompleteMenuItem from "./components/UserAutocompleteMenuItem";


class Autocomplete extends Component {

    constructor(props) {
        super(props);

        this.state = {
            openPopover: false,
        }
    }

    handleKeyPress = (e) => {
        if(e.key === 'ArrowUp'){
            e.preventDefault()
            if(e.target.previousElementSibling){
                e.target.previousElementSibling.focus()
            } else if(!this.props.showAbove) {
                this.props.onChangeFocusToInput()
            }
        }
        if(e.key === 'ArrowDown'){
            e.preventDefault()
            if(e.target.nextElementSibling){
                e.target.nextElementSibling.focus()
            } else if(this.props.showAbove) {
                this.props.onChangeFocusToInput()
            }
        }
    }

    handleSendChatAgentIntent = (e, intentId) => {
        this.props.onSendChatAgentIntent(e, intentId)
    }

    handleEditChatAgentIntent = (e, intentId) => {
        this.props.onEditChatAgentIntent(e, intentId)
    }

    handleSendUserSuggestion = (message) => {
        this.props.onSendUserSuggestion(message)
    }

    clickAwayHandler = () =>
    {
        this.props.flushTrainingPhraseList();
    }

    render() {

        const {anchorEl, searchString} = this.props;
        const localizationCode = getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null)

        //Checking for chatAgentMode and if # is present in message string
        const formattedSearchString = this.props.chatAgentMode
            ? (searchString.charAt(0) === "#" ? searchString.substring(1).trim().toLowerCase() : '')
            : searchString.trim().toLowerCase()

        //Filtering based on search string
        let filteredTrainingPhraseList = this.props.trainingPhraseList
            .filter(suggestion => suggestion.question
                .toLowerCase()
                .includes(formattedSearchString) )

        filteredTrainingPhraseList = filteredTrainingPhraseList.slice(0, 5)

        const isOpen = formattedSearchString.length > 2 && filteredTrainingPhraseList.length > 0

        const anchorOrigin = this.props.showAbove ?
            {
                vertical: 'top',
                horizontal: 'left'
            }
            :
            {
                vertical: 'bottom',
                horizontal: 'left'
            }

        const transformOrigin = this.props.showAbove ?
            {
                vertical: 'bottom',
                horizontal: 'left',
            }
            :
            {
                vertical: 'top',
                horizontal: 'left'
            }

        return (
            <Popover
                style={{minWidth: "80%"}}
                id={"autocomplete"}
                anchorEl={anchorEl}
                open={isOpen}
                transformOrigin={transformOrigin}
                anchorOrigin={anchorOrigin}
                disableRestoreFocus
                disableAutoFocus={true}
                disableEnforceFocus={true}
                classes={{
                    paper: this.props.showAbove? 'paperSuggestionsAbove' : 'paperSuggestionsBelow'

                }}
            >
                <ClickAwayListener onClickAway={this.clickAwayHandler}>
                    <div style={{backgroundColor: 'white'}} ref={this.props.innerRef} onKeyDown={(e) => this.handleKeyPress(e)}>
                        {filteredTrainingPhraseList.map(suggestion => {
                            const regex = new RegExp(`${formattedSearchString}`, "gi")
                            const replacedString = suggestion.question.replace(regex,'<b>$&</b>');

                            if(this.props.chatAgentMode){
                                return (
                                    <AdminAutocompleteMenuItem
                                        key={suggestion.id}
                                        onSendIntent={this.handleSendChatAgentIntent}
                                        replacedString={replacedString}
                                        suggestion={suggestion}
                                        localizationCode={localizationCode}
                                        onEditIntent={this.handleEditChatAgentIntent}
                                    />
                                )
                            } else {
                                return (
                                    <UserAutocompleteMenuItem
                                        key={suggestion.id}
                                        onSendSuggestion={this.handleSendUserSuggestion}
                                        replacedString={replacedString}
                                        suggestion={suggestion}
                                    />
                                )
                            }
                        })}
                    </div>
                </ClickAwayListener>
            </Popover>

        );
    }
}

export default React.forwardRef((props, ref) => <Autocomplete innerRef={ref} {...props}/>);

Autocomplete.propTypes = {
    anchorEl: PropTypes.object.isRequired,
    searchString: PropTypes.string.isRequired,
    trainingPhraseList: PropTypes.array.isRequired,
    onSendChatAgentIntent: PropTypes.func,
    flushTrainingPhraseList: PropTypes.func.isRequired,
    onEditChatAgentIntent: PropTypes.func,
    onSendUserIntent: PropTypes.func,
    language: PropTypes.object.isRequired,
    onChangeFocusToInput: PropTypes.func.isRequired,
    showAbove: PropTypes.bool.isRequired
}